import { useEffect, useState } from "react";
import { Flag, Check } from "lucide-react";
import api from "@/lib/api";
import { STAGES } from "./contactShared";
import { ACT_TYPES, fmtDT } from "./activityShared";

/** Timeline antéchronologique (activités + changements d'étape). `refresh` : incrémenter pour recharger. */
export default function ActivityTimeline({ contactId, opportunityId, refresh = 0, testId = "activity-timeline" }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    const params = opportunityId ? { opportunity_id: opportunityId } : { contact_id: contactId };
    api.get("/crm/activities", { params }).then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  }, [contactId, opportunityId, refresh]);
  if (items === null) return <div style={{ fontSize: 12, color: "#6e6e78" }}>Chargement…</div>;
  if (items.length === 0) return <div style={{ fontSize: 12, color: "#6e6e78" }} data-testid={`${testId}-empty`}>Aucune activité pour l'instant.</div>;
  return (
    <div className="flex flex-col" data-testid={testId}>
      {items.map((h) => {
        const t = ACT_TYPES[h.type] || ACT_TYPES.note; const color = h.type === "stage" && h.stage ? STAGES[h.stage]?.color || t.color : t.color;
        return (
          <div key={h.id} className="flex items-start" style={{ gap: 12, padding: "9px 4px", borderBottom: "0.5px solid #1e1e24" }} data-testid={`${testId}-item`} data-type={h.type}>
            <t.Icon size={16} style={{ color, flexShrink: 0, marginTop: 1 }} />
            <div className="flex flex-col" style={{ gap: 3, flex: 1, minWidth: 0 }}>
              <div className="flex items-center" style={{ gap: 8 }}>
                <span style={{ fontSize: 11, color, fontWeight: 500 }}>{h.type_label}</span>
                {h.opp_label && <span style={{ fontSize: 10.5, color: "#8a8a92" }}>· {h.opp_label}</span>}
                <span style={{ flex: 1 }} />
                <span style={{ fontSize: 11, color: "#8a8a92" }}>{h.by_name} · {fmtDT(h.at)}</span>
              </div>
              <span style={{ fontSize: 12.5, color: "#e8e8ec", whiteSpace: "pre-wrap" }}>{h.content}</span>
              {h.next_action?.label && <span className="inline-flex items-center" style={{ gap: 5, fontSize: 11, color: h.next_action.done_at ? "#4fc79c" : "#f3cfa6" }} data-testid={`${testId}-na`}>{h.next_action.done_at ? <Check size={11} /> : <Flag size={11} style={{ color: "#E0822E" }} />}{h.next_action.label} — {new Date(h.next_action.date).toLocaleDateString("fr-FR")}{h.next_action.done_at ? " · fait" : ""}</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
